import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Checkbox, IconButton } from '@mui/material';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { patchTableConfig } from '#action/table/configurable-table';
import defaultColumns from './default-columns';
import {
  SettingsHeadCell,
  TableCustomizeCell,
  CustomizeDialogTitle,
  OptionsCnt,
  ColumnOption,
  OptionWrapper,
  StyledArrow,
  ResetButton,
  ResetText
} from './styles';

const ColumnCustomize = ({ tableName, columns, order }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const customizeRef = useRef();
  const customizeButtonRef = useRef();

  const handleClickOutside = e => {
    if (customizeRef.current &&
      !customizeRef.current.contains(e.target) &&
      !customizeButtonRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  const handleToggle = field => {
    const newColumns = columns.map(c =>
      (c.id === field.id ? { ...c, isVisible: !c.isVisible } : c));

    dispatch(patchTableConfig(tableName, newColumns));
  };

  const handleReset = () => {
    dispatch(patchTableConfig(tableName, defaultColumns[tableName]));
  };

  return (
    <>
      <SettingsHeadCell width={20}>
        <IconButton
          onClick={() => setOpen(!open)}
          ref={customizeButtonRef}
        >
          <SettingsApplicationsIcon color={open ? 'secondary' : ''} />
        </IconButton>
      </SettingsHeadCell>
      {open && (
        <TableCustomizeCell ref={customizeRef}>
          <CustomizeDialogTitle>Table setup</CustomizeDialogTitle>
          <OptionsCnt>
            {columns.map(column => (!column.hidden && !column.root && (
              <OptionWrapper sorted={column.disabled} key={column.label}>
                <ColumnOption
                  sorted={column.disabled}
                  control={
                    <Checkbox
                      checked={column.isVisible}
                      onChange={() => handleToggle(column)}
                      disabled={column.disabled}
                    />
                  }
                  label={column.label}
                />
                {column.disabled && <StyledArrow order={order} />}
              </OptionWrapper>
            )
            ))}
          </OptionsCnt>
          <ResetButton onClick={handleReset}>
            <ResetText>RESET TO DEFAULT</ResetText>
          </ResetButton>
        </TableCustomizeCell>
      )}
    </>
  );
};

export default ColumnCustomize;
